import { Spinner } from 'baseui/spinner';
import { useStyletron, withStyle } from 'styletron-react';

const CustomSpinner = withStyle(Spinner, {
  width: '96px',
  height: '96px',
  borderLeftWidth: '12px',
  borderRightWidth: '12px',
  borderTopWidth: '12px',
  borderBottomWidth: '12px',
  borderTopColor: 'pink',
});

const Loader = () => {
  const [css] = useStyletron();
  return (
    <div
      className={css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
      })}
    >
      <CustomSpinner />
    </div>
  );
};
export default Loader;
